import { create } from "zustand";

const initialState = {
  initAddress: null,
  address: null,
  providerName: "",
  providerType: [],
  providerTypeMatchAll: false,
  dayOfAvailability: "",
  timeOfAvailability: "",
  data: [],
  loading: false,
  selectedProvider: null,
  currentPage: 1,
  resLimit: 25,
  resultCount: 0,
  openProviderDetail: false,
  assignedProvider: null,
  disableSaveButton: true,
  disableOONButton: false,
  addressSource: null,
  inNetwork: 1,
  showMap: true,
  showCustomSearch: false,
  customAddressSearchText: "",
  initMaxDistance: 0,
  maxDistance: 0,
  mapDisplayData: [],
  zoom: 9,
  selectedCenter: null,
  isProviderMapPage: false,
  caseId: null,
  handleOnClickCreateCustomProvider: () => {},
  handleOnClickAddProvider: () => {},
};

export const useProviderSearchStore = create((set) => ({
  ...initialState,

  setProviderName: (name) => set({ providerName: name }),
  setProviderType: (types) => set({ providerType: types }),
  setProviderTypeMatchAll: (value) => set({ providerTypeMatchAll: value }),
  setInitAddress: (address) => set({ initAddress: address }),
  setAddress: (address) => set({ address: address }),
  setDayOfAvailability: (day) => set({ dayOfAvailability: day }),
  setTimeOfAvailability: (time) => set({ timeOfAvailability: time }),
  setData: (data) => set({ data }),
  setLoading: (loading) => set({ loading }),
  selectProvider: (provider) => set({ selectedProvider: provider }),
  setOpenProviderDetail: (value) => set({ openProviderDetail: value }),
  setAssignedProvider: (value) => set({ assignedProvider: value }),
  setDisableSaveButton: (value) => set({ disableSaveButton: value }),
  setDisableOONButton: (value) => set({ disableOONButton: value }),
  setAddressSource: (value) => set({ addressSource: value }),
  setInNetwork: (value) => set({ inNetwork: value }),
  setShowMap: (value) => set({ showMap: value }),
  setShowCustomSearch: (value) => set({ showCustomSearch: value }),
  setCustomAddressSearchText: (value) => set({ customAddressSearchText: value }),
  setInitMaxDistance: (value) => set({ initMaxDistance: value }),
  setMaxDistance: (value) => set({ maxDistance: value }),
  setMapDisplayData: (value) => set({ mapDisplayData: value }),
  setZoom: (value) => set({ zoom: value }),
  setSelectedCenter: (value) => set({ selectedCenter: value }),
  setIsProviderMapPage: (value) => set({ isProviderMapPage: value }),
  setCaseId: (value) => set((state) => (state.caseId === value ? state : { caseId: value })),
  setHandleOnClickCreateCustomProvider: (value) =>
    set({ handleOnClickCreateCustomProvider: value }),
  setHandleOnClickAddProvider: (value) => set({ handleOnClickAddProvider: value }),

  reset: () => set(initialState),

  setCurrentPage: (page) => set({ currentPage: page }),
  setResLimit: (limit) => set({ resLimit: limit }),
  setResultCount: (count) => set({ resultCount: count }),
  resetCurrentPage: () => set({ currentPage: 1 }),
}));
